import { render, staticRenderFns } from "./Reserves.vue?vue&type=template&id=18b872c6&scoped=true&"
import script from "./Reserves.vue?vue&type=script&lang=js&"
export * from "./Reserves.vue?vue&type=script&lang=js&"
import style0 from "./Reserves.vue?vue&type=style&index=0&id=18b872c6&scoped=true&lang=css&"
import style1 from "./Reserves.vue?vue&type=style&index=1&lang=scss&"
import style2 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b872c6",
  null
  
)

export default component.exports